import { AspectRatio, Skeleton, SkeletonText, Stack } from "@chakra-ui/react"
import React from "react"

const ProductCardLoader = () => (
  <Stack>
    <AspectRatio ratio={82 / 107}>
      <Skeleton />
    </AspectRatio>
    <SkeletonText />
  </Stack>
)

export default ProductCardLoader
